import CompanyGenerateTable from './companyGenerateTable.container';

export default CompanyGenerateTable;
